import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the top when the route changes, and when the catalogue page number changes
 * (?page=N). Filter changes keep the scroll position so the sidebar doesn't jump.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  const page = new URLSearchParams(search).get("page") || "1";

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, page]);

  return null;
}
